<ng-container *ngIf="mergeRequests.length === 0">
  <p
    class="op-tab-content--text-box"
    [innerHTML]="getEmptyText()"
  ></p>
</ng-container>

<gitlab-merge-request [mergeRequest]="mergeRequest" *ngFor="let mergeRequest of mergeRequests"></gitlab-merge-request>
